var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon data perso",
    viewBox: "0 0 16.002 16.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17540.309 16H17532V0h16v8.315a5.945 5.945 0 1 0-7.691 7.685z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-17531.998)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    style: {
      fill: "none"
    },
    transform: "translate(.002)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.277 15.707-1.844-1.842a3.908 3.908 0 0 1-1.982.532 3.953 3.953 0 0 1-3.947-3.947 3.95 3.95 0 0 1 3.947-3.947 3.95 3.95 0 0 1 3.945 3.947 3.889 3.889 0 0 1-.535 1.984l1.842 1.842a1.013 1.013 0 0 1 0 1.431 1.019 1.019 0 0 1-.711.3 1.014 1.014 0 0 1-.715-.3zM8.519 10.45a1.933 1.933 0 0 0 1.932 1.93 1.931 1.931 0 0 0 1.93-1.93 1.931 1.931 0 0 0-1.93-1.93 1.933 1.933 0 0 0-1.931 1.93z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.002 15.004v-12a1 1 0 0 0-1-1 1 1 0 0 0-1 1v12a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm3 0v-10a1 1 0 0 0-1-1 1 1 0 0 0-1 1v10a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm3 0v-13a1 1 0 0 0-1-1 .993.993 0 0 0-1 1v13a.993.993 0 0 0 1 1 1 1 0 0 0 1-1zm3 0v-12a1 1 0 0 0-1-1 1 1 0 0 0-1 1v12a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm3-1v-10a1 1 0 0 0-1-1 1 1 0 0 0-1 1v10a1 1 0 0 0 1 1 1 1 0 0 0 1-1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDataIcon);
export default __webpack_public_path__ + "static/media/custom-data-icon.b9a053b79090eece7af246d83571560c.svg";
export { ForwardRef as ReactComponent };